import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { APP_URL } from '../utils/config.js'
import {
  setCanProceedToNextStep,
  setCustomTamplateNumberOfFasteners,
  setFastenerPlacement,
  setSelectedFastener,
} from '../actions/generalActions.js'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import CushionFastenerPlacementSelector from './CushionFastenerPlacementSelector.js'
import { BarLoader } from 'react-spinners'
import { displayToast, getEstimate, scrollTo, sendGtag } from '../utils/utils.js'
import CustomTamplateFastenerSelector from './CustomTamplateFastenerSelector.js'
import StepTitle from './StepTitle/index.js'
import None from '../../assets/fasteners/none.webp'
import Ties from '../../assets/fasteners/ties.webp'
import Velcro from '../../assets/fasteners/velcro.webp'
import Snaps from '../../assets/fasteners/snaps.webp'
import { debounce } from 'lodash'

class CushionFastenerSelector extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isTabletLayout: false,
    }
  }

  componentDidMount() {
    const { dispatch, general, cushion } = this.props
    const { cushionFasteners } = cushion
    const { fasteners, enableScrollTo, type, isNoOfFastener } = general

    if (window.innerWidth < 1024) {
      this.setState({ isTabletLayout: true })
    }

    window.addEventListener('resize', this.checkForTabletLayout)

    if (!fasteners) {
      dispatch(setCanProceedToNextStep(false))
    }
    if (fasteners) {
      if (type?.id === 11741) {
        dispatch(
          setSelectedFastener(
            fasteners,
            fasteners.name === 'None' ? true : isNoOfFastener ? null : false,
          ),
        )
      } else {
        const isAnyFastenerSelected =
          general.fastenerPlacement.checkboxes.some((placement) => parseInt(placement) === 1) ||
          general.fastenerPlacement.mirroredCheckboxes.some(
            (placement) => parseInt(placement) === 1,
          )
        dispatch(
          setSelectedFastener(
            fasteners,
            fasteners.name === 'None' ? true : isAnyFastenerSelected ? null : false,
          ),
        )
      }
    }
    if (type?.id === 11752) {
      const defaultFastener = cushionFasteners.find((shape) => shape.id === 718)
      if (defaultFastener) {
        this._selectCushionFastener(defaultFastener)()
      }
    }
    if (fasteners?.name === 'None') {
      setTimeout(() => {
        dispatch(
          setFastenerPlacement({
            checkboxes: [0, 0, 0, 0, 0],
            mirroredCheckboxes: [0, 0, 0, 0, 0],
          }),
        )
      }, 100)
    }
    setTimeout(() => {
      this._getPrice()
    }, 100)

    if (enableScrollTo === true) {
      scrollTo('header-section')
    }
  }

  componentDidUpdate(prevProps) {
    const { params, dispatch, cushion, history, general } = this.props
    const { cushionFasteners } = cushion
    const { fasteners } = general
    const { fastenerId } = params.fasteners

    if (
      (!prevProps.general.fasteners || prevProps.general.fasteners.name === 'None') &&
      fasteners?.name !== 'None'
    ) {
      scrollTo('cushion-fastener-placement-selector')
    }

    if (prevProps.cushion.cushionFasteners !== cushionFasteners) {
      if (fastenerId !== 'fasteners' && parseInt(fastenerId) && cushionFasteners) {
        if (fasteners.name === 'None') {
          dispatch(
            setFastenerPlacement({
              checkboxes: [0, 0, 0, 0, 0],
              mirroredCheckboxes: [0, 0, 0, 0, 0],
            }),
          )
        }
        let selectedFastener = cushionFasteners.find(
          (fastener) => fastener.id === parseInt(fastenerId),
        )
        let isAnyFastenerSelectedOrIsNoOfFasteners

        if (params?.type?.id === '11741') {
          isAnyFastenerSelectedOrIsNoOfFasteners = general?.fastenerPlacement
        } else {
          isAnyFastenerSelectedOrIsNoOfFasteners =
            general.fastenerPlacement.checkboxes.some((placement) => parseInt(placement) === 1) ||
            general.fastenerPlacement.mirroredCheckboxes.some(
              (placement) => parseInt(placement) === 1,
            )
        }
        if (selectedFastener && isAnyFastenerSelectedOrIsNoOfFasteners) {
          dispatch(setCanProceedToNextStep(true))
        } else {
          if (params.type?.id !== '11741') {
            history.push(`/cd/${params.category}/type`)
            displayToast(
              'The URL you were trying to access is broken. Please reselect your options',
              'error',
            )
          }
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkForTabletLayout)
  }

  checkForTabletLayout = debounce(() => {
    this.setState({ isTabletLayout: window.innerWidth <= 1024 })
  }, 100)

  _getPrice = () => {
    const { dispatch, general, params } = this.props
    setTimeout(() => {
      getEstimate(dispatch, general, params)()
    }, 100)
  }

  _selectCushionFastener = (fastener) => () => {
    const { dispatch, general } = this.props

    if (fastener.id === general.fasteners?.id) {
      return
    }

    sendGtag('select_style_fasteners', fastener.name)

    if (fastener.name === 'None') {
      dispatch(setCustomTamplateNumberOfFasteners(null))
      dispatch(
        setFastenerPlacement({
          checkboxes: [0, 0, 0, 0, 0],
          mirroredCheckboxes: [0, 0, 0, 0, 0],
        }),
      )
    }

    if (general?.type?.id === 11741) {
      const isNoOfFastener = general.noOfFasteners
      dispatch(
        setSelectedFastener(
          fastener,
          fastener.name === 'None' ? true : isNoOfFastener ? null : false,
        ),
      )
    } else {
      const isAnyFastenerSelected =
        general.fastenerPlacement.checkboxes.some((placement) => parseInt(placement) === 1) ||
        general.fastenerPlacement.mirroredCheckboxes.some((placement) => parseInt(placement) === 1)
      dispatch(
        setSelectedFastener(
          fastener,
          fastener.name === 'None' ? true : isAnyFastenerSelected ? null : false,
        ),
      )
    }

    setTimeout(() => {
      this._getPrice()
    }, 100)
  }

  _getFastenerTypeImage = (param) => {
    switch (param) {
      case 'velcro':
        return Velcro
      case 'ties':
        return Ties
      case 'snaps':
        return Snaps
      case 'none':
        return None
    }
  }

  _renderFasteners = () => {
    const { general, cushion } = this.props
    const { fasteners } = general
    const { cushionFasteners } = cushion

    if (cushionFasteners === null) {
      return <BarLoader color={'#93C44E'} css={{ position: 'absolute' }} />
    }
    return cushionFasteners.map((fastenerType) => {
      const { isTabletLayout } = this.state
      const { general } = this.props
      return (
        <>
          <div
            key={fastenerType.id}
            onClick={this._selectCushionFastener(fastenerType)}
            className={`cushion-fastener-selector-card ${fasteners?.id === fastenerType.id ? 'active' : ''}`}
          >
            <div className={'cushion-fastener-selector-card-checkbox'}>
              {fasteners?.id === fastenerType.id && (
                <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
              )}
            </div>
            <div className="fastener-image-wrapper">
              <img
                className={'cushion-fastener-selector-card-image'}
                src={this._getFastenerTypeImage(fastenerType.name.toLowerCase())}
              />
            </div>
            <div className="card-title">{fastenerType.name}</div>
          </div>
          {isTabletLayout &&
          general?.type?.id === 11741 &&
          fasteners?.id === fastenerType.id &&
          fasteners?.name !== 'None' ? (
            <CustomTamplateFastenerSelector />
          ) : null}
        </>
      )
    })
  }

  render() {
    const { isTabletLayout } = this.state
    const { general, currentLocationIndex } = this.props
    const { fasteners, shape } = general
    const name = general?.type?.name

    return (
      <>
        <StepTitle
          name={name}
          step={currentLocationIndex - 1}
          attributes={general?.type?.attributes}
        />
        <div
          className={`cushion-designer-layout ${general.type?.id === 11741 ? 'custom-fastener-layout' : ''} fasteners ${fasteners?.name.toLowerCase() || 'none'}`}
        >
          {fasteners && fasteners.name.toLowerCase() !== 'none' && general.type?.id !== 11741 ? (
            <CushionFastenerPlacementSelector />
          ) : null}
          <div
            className={`cushion-fastener-selector ${fasteners?.name.toLowerCase() || 'none'} ${shape?.slug === 'trapezoid' ? 'trapezoid-shape' : ''}`}
          >
            {this._renderFasteners()}
          </div>
          {general.type?.id === 11741 && !isTabletLayout ? (
            <CustomTamplateFastenerSelector
              hideDropdown={!(fasteners && fasteners.name.toLowerCase() !== 'none')}
            />
          ) : null}
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  cushion: state.cushion,
})

export default withRoutingTracker(connect(mapStateToProps)(CushionFastenerSelector))
